import {React, useEffect, useState} from 'react';
import Sidebar from './components/Sidebar';
import TopHeader from './components/TopHeader';
import { BrowserRouter as Router, Routes as Switch, Route, useLocation, Navigate } from 'react-router-dom';
import Dashboard from './components/pages/Dashboard';
import CategoriesManagement from './components/pages/CategoriesManagement';
import BlockHistory from './components/pages/BlockHistory';
import CustomersManagement from './components/pages/CustomersManagement';
import ClockSystem from './components/pages/ClockSystem';
import AntiSpam from './components/pages/AntiSpam';
import CommunitySettings from './components/pages/CommunitySettings';
import {Login} from './components/pages/Login';
import {Logout} from './components/pages/Logout';
import AuthRoute from './components/routes/AuthRoute';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import {Dialog} from '@mui/material';
import { hideErrorDialog } from "./features/errorDialog";
import { LoginByToken } from './components/pages/LoginByToken';
import { getPortalAccess } from './Helper';
import { getActiveAppName, getBrandDisplayName, getBrandFavicon } from './Constants';

function App(props) {
  const user = useSelector((state) => state.user.value);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const errorDialog = useSelector((state) => state.errorDialog.value);

  const getWindowSize = () => {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
  }
  const [windowSize, setWindowSize] = useState(getWindowSize());

  const handleErrorDialogClose = () => dispatch(hideErrorDialog());

  useEffect(() => {
    function handleWindowResize() { setWindowSize(getWindowSize()); }
    window.addEventListener('resize', handleWindowResize);
    document.body.classList.add(getActiveAppName());
    document.title = getBrandDisplayName();   // browser-tab title per reseller
    // favicon per reseller — from the brand's own index folder
    let favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = getBrandFavicon();
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <>
      <Router>
        <AppRoutes user={user} windowSize={windowSize} />
      </Router>
      <Dialog
        open={errorDialog.isOpen && errorDialog.page === "all"}
        onClose={handleErrorDialogClose}
        PaperProps={{ className: 'err-dialog-paper' }}
      >
        <div className='err-dialog'>
          <div className='err-dialog-header'>
            <div className='err-dialog-icon'>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <h3 className='err-dialog-title'>{t(errorDialog.title)}</h3>
          </div>
          <div className='err-dialog-body'>
            <p className='err-dialog-text'>{t(errorDialog.text)}</p>
            <button className='err-dialog-btn' onClick={handleErrorDialogClose}>{t('Close')}</button>
          </div>
        </div>
      </Dialog>
    </>
  );
}

function AppRoutes({ user, windowSize }) {
  // גישת הקהילה למקטעי הפורטל — חוסמים גם גישה ישירה בכתובת (מנתבים לדשבורד). הגישה נחסמת קשיח גם בשרת.
  const pa = getPortalAccess();
  return (
    <div className={user.isLoggedIn ? 'app-layout' : ''}>
      {user.isLoggedIn && <Sidebar />}
      <div className={user.isLoggedIn ? 'app-content' : ''}>
        {/* TopHeader removed per user request */}
        <Switch>
          <Route path='/' exact element={<AuthRoute isLoggedIn={user.isLoggedIn}><Dashboard /></AuthRoute>} />
          <Route path='/dashboard' element={<AuthRoute isLoggedIn={user.isLoggedIn}><Dashboard /></AuthRoute>} />
          <Route path='/blocks-management' element={<AuthRoute isLoggedIn={user.isLoggedIn}>{pa.blocks ? <Navigate to='/dashboard' replace /> : <CategoriesManagement isDesktop={true}/>}</AuthRoute>} />
          <Route path='/blocks-history' element={<AuthRoute isLoggedIn={user.isLoggedIn}>{pa.blocks ? <Navigate to='/dashboard' replace /> : <BlockHistory />}</AuthRoute>} />
          <Route path='/customers-management' element={<AuthRoute isLoggedIn={user.isLoggedIn}>{pa.members ? <Navigate to='/dashboard' replace /> : <CustomersManagement isDesktop={true} />}</AuthRoute>} />
          <Route path='/clock-system' element={<AuthRoute isLoggedIn={user.isLoggedIn}>{pa.watch ? <Navigate to='/dashboard' replace /> : <ClockSystem isDesktop={true} />}</AuthRoute>} />
          <Route path='/anti-spam' element={<AuthRoute isLoggedIn={user.isLoggedIn}>{pa.anti_spam ? <Navigate to='/dashboard' replace /> : <AntiSpam isDesktop={true} />}</AuthRoute>} />
          <Route path='/community-settings' element={<AuthRoute isLoggedIn={user.isLoggedIn}>{pa.permissions ? <Navigate to='/dashboard' replace /> : <CommunitySettings />}</AuthRoute>} />
          <Route path='/login' element={<Login />} />
          <Route path='/login-by-token' element={<LoginByToken />} />
          <Route path='/logout' element={<AuthRoute isLoggedIn={user.isLoggedIn}><Logout /></AuthRoute>} />
        </Switch>
      </div>
    </div>
  );
}

export default App;
